import * as React from "react";

export enum KeyboardKey {
    Space,
    Tab,
    Caps,
    Enter,
    HideKeyboard,
    LanguageSwitch
}

export default class KeyBoardKeysSymbolFactory {
    public static GenerateKey(keyType: KeyboardKey, id: string): JSX.Element {
        let path = "";
        switch (keyType) {
            case KeyboardKey.Space:
                path = "M18 9v4H6V9H4v6h16V9z";
                break;
            case KeyboardKey.Tab:
                path = "M11.59 7.41L15.17 11H1v2h14.17l-3.59 3.59L13 18l6-6-6-6-1.41 1.41zM20 6v12h2V6h-2z";
                break;
            case KeyboardKey.Caps:
                path = "M12 8.41L16.59 13 18 11.59l-6-6-6 6L7.41 13 12 8.41zM6 18h12v-2H6v2z";
                break;
            case KeyboardKey.Enter:
                path = "M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7z";
                break;
            case KeyboardKey.HideKeyboard:
                path = "M20 3H4c-1.1 0-1.99.9-1.99 2L2 15c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 3h2v2h-2V6zm0 3h2v2h-2V9zM8 6h2v2H8V6zm0 3h2v2H8V9zm-1 2H5V9h2v2zm0-3H5V6h2v2zm9 7H8v-2h8v2zm0-4h-2V9h2v2zm0-3h-2V6h2v2zm3 3h-2V9h2v2zm0-3h-2V6h2v2zm-7 15l4-4H8l4 4z";
                break;
            case KeyboardKey.LanguageSwitch:
                path = "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z";
                break;
        }
        return path ? this.createSvgSymbol(id, path) : null;
    }

    private static createSvgSymbol = (id, path) => (
        <span id={id}>
            <svg xmlns="http://www.w3.org/2000/svg" id={id + "-svg"} width="32" height="40" viewBox="0 0 24 24">
                <path id={id + "-path"} d={path} />
            </svg>
        </span>
    );
}


// WEBPACK FOOTER //
// ./src/components/KeyboardKiosk/KeyBoardKeysSymbolFactory.tsx